import { createWithEqualityFn } from "zustand/traditional";

import { THE_COSMOPOLITAN } from "../src/scripts/core/constants.js";

const useStoreDollHouseMap = createWithEqualityFn(
  (set, get) => ({
    sourceAreaSelected: "",
    destinationAreaSelected: "",
    routeTypeSelected: "all",
    isRouteSubmitted: false,
    currentCosmoPolitanLevel: "cosmo_level_2",
    currentAriaMapLevel: "area_level_1",
    currentSidebarMenuSelected: "",
    sourcePoidSelected: "",
    destinationPoidSelected: "",
    svgPoiPopNeedtoShow: false,
    svgPoiPopTitle: "",
    svgPoiPopContent: "",
    svgPoiPopLink: "",
    svgPoiPopPositionLeft: "",
    svgPoiPopPositionTop: "",
    isDrawerSidebarOpened: true,
    BellagioHighlightPoiStore: "",
    CosmoHighlightPoiStore: "",
    AriaL1HighlightPoiStore: "",
    AriaL2HighlightPoiStore: "",
    VdaraHighlightPoiStore: "",
    NomadHighlightPoiStore: "",
    DistrictHighlightPoiStore: "",
    ParkMgmHighlightPoiStore: "",
    panComponentObj: null,
    isPopupneedToshow: false,
    popupmessage: "",
    isSvgRoutePathVisibility: false,
    sidebarmenuPoiSelected: "",
    userid: null,
    feedbacktitle: "",
    feedbackVisibiity: false,
    feedbackSubmittedStatus: false,
    updateFeedbackSbtStatus: (stats) => {
      set(() => ({
        feedbackSubmittedStatus: stats,
      }));
    },
    updateFeedbackVisibility: (stats) => {
      set(() => ({
        feedbackVisibiity: stats,
      }));
    },
    updateFeedbackTitle: (text) => {
      set(() => ({
        feedbacktitle: text,
      }));
    },
    updateSvgRoutePathVisibility: (stats) => {
      set(() => ({
        isSvgRoutePathVisibility: stats,
      }));
    },
    changePopupvisibility: (stats, message) => {
      set(() => ({
        isPopupneedToshow: stats,
        popupmessage: message,
      }));
    },

    resetVdaraHighlightPOI: () => {
      set(() => ({
        VdaraHighlightPoiStore: "",
      }));
    },

    resetParkMgmHighlightPOI: () => {
      set(() => ({
        ParkMgmHighlightPoiStore: "",
      }));
    },

    resetNomadHighlightPOI: () => {
      set(() => ({
        NomadHighlightPoiStore: "",
      }));
    },

    resetDistrictHighlightPOI: () => {
      set(() => ({
        DistrictHighlightPoiStore: "",
      }));
    },

    resetCosmoHighlightPOI: () => {
      set(() => ({
        CosmoHighlightPoiStore: "",
      }));
    },

    resetAriaLevel1HighlightPOI: () => {
      set(() => ({
        AriaL1HighlightPoiStore: "",
      }));
    },

    resetAriaLevel2HighlightPOI: () => {
      set(() => ({
        AriaL2HighlightPoiStore: "",
      }));
    },

    resetBellagioHighlightPOI: () => {
      set(() => ({
        BellagioHighlightPoiStore: "",
      }));
    },

    setsubmitFindRoute: (changestatus) => {
      set(() => ({
        isRouteSubmitted: changestatus,
      }));
    },
    setSourceAreaSelected: (val) => {
      set(() => ({
        sourceAreaSelected: val,
      }));
    },
    setDestinationAreaSelected: (val) => {
      set(() => ({
        destinationAreaSelected: val,
      }));
    },
    setRouteTypeSelected: (val) => {
      set(() => ({
        routeTypeSelected: val,
      }));
    },
    updatePanComponentObj: (val) => {
      set(() => ({
        panComponentObj: val,
      }));
    },
    changeDrawerStatus: (status) => {
      set(() => ({
        isDrawerSidebarOpened: status,
      }));
    },

    showSvgPopUp: (data) => {
      // console.log(data);
      set(() => ({
        poid: data.poid,
        svgPoiPopNeedtoShow: true,
        svgPoiPopTitle: data.title,
        svgPoiPopContent: data.content,
        svgPoiPopLink: data.link,
        svgPoiPopPositionLeft: data.left,
        svgPoiPopPositionTop: data.top,
      }));
    },

    svgPopupNotshow: () => {
      set(() => ({
        svgPoiPopNeedtoShow: false,
      }));
    },
    hideSvgPopUp: () => {
      // console.log("hide");
      set(() => ({
        poid: "",
        svgPoiPopNeedtoShow: false,
        svgPoiPopTitle: "",
        svgPoiPopContent: "",
        svgPoiPopLink: "",
        svgPoiPopPositionLeft: "",
        svgPoiPopPositionTop: "",
      }));
    },
    removeSourcePoiSelected: () => {
      set(() => ({
        sourcePoidSelected: "",
      }));
    },
    removeDestinationPoiSelected: () => {
      set(() => ({
        destinationPoidSelected: "",
      }));
    },
    highlightPOIAreaSelection: (poiObj) => {
      if (poiObj.level !== "") {
        if (
          poiObj.level === "area_level_1" ||
          poiObj.level === "area_level_2"
        ) {
          set(() => ({
            currentAriaMapLevel: poiObj.level,
          }));
        }
        if (
          poiObj.level === "cosmo_level_1" ||
          poiObj.level === "cosmo_level_2" ||
          poiObj.level === "cosmo_level_3" ||
          poiObj.level === "cosmo_level_4"
        ) {
          set(() => ({
            currentCosmoPolitanLevel: poiObj.level,
          }));
        }
      }

      if (poiObj.map === "Tcolv") {
        set((state) => ({
          CosmoHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      if (poiObj.map === "Bellagio") {
        set((state) => ({
          BellagioHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      if (poiObj.map === "Vdara") {
        set((state) => ({
          VdaraHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      if (poiObj.map === "Nomad") {
        set((state) => ({
          NomadHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      if (poiObj.map === "DistrictHighlight") {
        set((state) => ({
          DistrictHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      if (poiObj.map === "ParkMgm") {
        set((state) => ({
          ParkMgmHighlightPoiStore: poiObj.poiId,
          sidebarmenuPoiSelected: poiObj.poiId,
        }));
      }

      let currentAriaMapLevel = get().currentAriaMapLevel;

      if (poiObj.poiId === "aria_level_restaurent") {
        if (currentAriaMapLevel === "area_level_1") {
          set((state) => ({
            AriaL1HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }
        if (currentAriaMapLevel === "area_level_2") {
          set((state) => ({
            AriaL2HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }
      } else if (poiObj.poiId === "aria_guest_elevators") {
        if (currentAriaMapLevel === "area_level_1") {
          set((state) => ({
            AriaL1HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }
        if (currentAriaMapLevel === "area_level_2") {
          set((state) => ({
            AriaL2HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }
      } else {
        if (poiObj.map === "Aria1") {
          set((state) => ({
            AriaL1HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }

        if (poiObj.map === "Aria2") {
          set((state) => ({
            AriaL2HighlightPoiStore: poiObj.poiId,
            sidebarmenuPoiSelected: poiObj.poiId,
          }));
        }
      }
    },
    updatePOIPointAreaSelection: (poiObj) => {
      const source = get().sourcePoidSelected;

      // const destination = get().destinationPoidSelected;

      if (poiObj.level !== "") {
        if (
          poiObj.level === "area_level_1" ||
          poiObj.level === "area_level_2"
        ) {
          set(() => ({
            currentAriaMapLevel: poiObj.level,
          }));
        }
        if (
          poiObj.level === "cosmo_level_1" ||
          poiObj.level === "cosmo_level_2" ||
          poiObj.level === "cosmo_level_3" ||
          poiObj.level === "cosmo_level_4"
        ) {
          set(() => ({
            currentCosmoPolitanLevel: poiObj.level,
          }));
        }
      }

      if (source === "") {
        set(() => ({
          sourcePoidSelected: poiObj.poiId,
          AriaL1HighlightPoiStore: "",
          AriaL2HighlightPoiStore: "",
          CosmoHighlightPoiStore: "",
          BellagioHighlightPoiStore: "",
          VdaraHighlightPoiStore: "",
          NomadHighlightPoiStore: "",
          DistrictHighlightPoiStore: "",
          ParkMgmHighlightPoiStore: "",
        }));
      } else {
        set(() => ({
          destinationPoidSelected: poiObj.poiId,
          AriaL1HighlightPoiStore: "",
          AriaL2HighlightPoiStore: "",
          CosmoHighlightPoiStore: "",
          BellagioHighlightPoiStore: "",
          VdaraHighlightPoiStore: "",
          NomadHighlightPoiStore: "",
          DistrictHighlightPoiStore: "",
          ParkMgmHighlightPoiStore: "",
        }));
      }
    },
    updateMapAreaSelection: (selection) => {
      // console.log('selection', selection)
      let cosmoLevel = get().currentCosmoPolitanLevel;
      if (selection === THE_COSMOPOLITAN) {
        cosmoLevel = "cosmo_level_2";
      }
      set(() => ({
        AriaL1HighlightPoiStore: "",
        AriaL2HighlightPoiStore: "",
        CosmoHighlightPoiStore: "",
        BellagioHighlightPoiStore: "",
        VdaraHighlightPoiStore: "",
        NomadHighlightPoiStore: "",
        DistrictHighlightPoiStore: "",
        ParkMgmHighlightPoiStore: "",
        currentSidebarMenuSelected: selection,
        currentCosmoPolitanLevel: cosmoLevel,
      }));
    },
    handleLevelChangeCosmo: (level) => {
      set(() => ({
        currentSidebarMenuSelected: level,
      }));
    },
    handleLevelChangeAria: (level) => {
      set(() => ({
        currentSidebarMenuSelected: level,
      }));
    },
    changeCosmoPolitanLevel: (level) =>
      set(() => ({
        currentCosmoPolitanLevel: level,
      })),

    changeAriaMapLevel: (level) =>
      set(() => ({
        currentAriaMapLevel: level,
      })),

    poidSelectionSource: (poid) =>
      set(() => ({
        sourcePoidSelected: poid,
      })),

    poidSelectionDestination: (poid) =>
      set(() => ({
        destinationPoidSelected: poid,
      })),

    updateLoginData: (id) => {
      set(() => ({
        userid: id,
      }));
    },
    resetDollhouseMap: () => {
      set(() => ({
        currentCosmoPolitanLevel: "cosmo_level_2",
        currentAriaMapLevel: "area_level_1",
        currentSidebarMenuSelected: "",
        sourcePoidSelected: "",
        destinationPoidSelected: "",
        svgPoiPopNeedtoShow: false,
        svgPoiPopTitle: "",
        svgPoiPopContent: "",
        svgPoiPopLink: "",
        svgPoiPopPositionLeft: "",
        svgPoiPopPositionTop: "",
        AriaL1HighlightPoiStore: "",
        AriaL2HighlightPoiStore: "",
        CosmoHighlightPoiStore: "",
        BellagioHighlightPoiStore: "",
        VdaraHighlightPoiStore: "",
        NomadHighlightPoiStore: "",
        DistrictHighlightPoiStore: "",
        ParkMgmHighlightPoiStore: "",
        sourceAreaSelected: "",
        destinationAreaSelected: "",
        routeTypeSelected: "all",
      }));
    },
  }),
  Object.is
);

export { useStoreDollHouseMap };
